import * as d3 from 'd3'

export default {
  data: () => ({
    selectedItems: null,
    getItems: null,
  }),

  methods: {

    set_selectedItems() {  
      this.selectedItems = { 
        ...this.selectedItems,
        stage: this.current.stage,
        zone: this.current.zone,
        svg: this.current.svg,
        sn: this.current.sn,
        toggle: this.Toggle,
      }
    },

    draw_PDF() {
      this.current.stage = this.getItems.stage
      this.current.zone = this.getItems.zone
      this.current.svg = this.getItems.svg
      this.current.sn = this.getItems.sn
      this.current.toggle = this.getItems.toggle

      switch(this.current.stage) {
        case 'MODULE':  
          this.pdf_Module()
          break
        case 'EQ':         
          this.pdf_EQ()
          break
        default:      
          this.draw_Model_Overall()
          break
      }      
    },
    pdf_Module(){
        let data = this.areaSummary.find(f=> f.MODULE =='Y' && f.ZONE == this.current.zone)

        this.draw_Model_Module(data)
    },
    pdf_EQ(){
      let _d = this.svgFile.find(f=> f.ZONE == this.current.zone && f.SVG == this.current.svg)   

      this.model_Equipment = this.svg
      .append('g')
      .attr('id', `MODEL_EQUIPMENT`)
      .attr('transform', `translate(0,0)`)      

      this.loadSvg(
        this.model_Equipment, {
        x: 0, y: 0,
        url : `/Visualization/Layout_Equipment/SVGs/${_d.ZONE}_${_d.SVG}.svg`
      }).then(() => {

        d3.selectAll('text').style('font-family', 'roboto')
        this.eqList.filter(f=> f.ZONE == _d.ZONE && f.SVG == _d.SVG).forEach(d=>{
          d3.select(`#NO-${d.ID}`)
          .attr('cursor', 'pointer').call(this.call_Equipment, d)
          d3.select(`#C-${d.ID}`)
          .style('fill', ()=> {
            let color = '#fff'
            if(d.PO_DATE) color = '#85C7E5'
            if(d.FAT_ACT) color = '#F7BACE'
            if(d.ATA) color = '#F6D15E'
            if(d.INSTALL) color = '#8DBB3F'
            return color
          })
          if(d.ETA_SRD < 0) {
            d3.select(`#NO-${d.ID}`).selectAll('text').style('fill', 'red')
          }
        })
          
        this.canvas_Equipment = this.svg
        .append('g')
        .attr('id', `CANVAS_EQUIPMENT`)
        .attr('transform', `translate(0,0)`)        

        d3.select(`#TITLE_MAIN`).text(`${_d.ZONE} MODULE -`)
        d3.select(`#TITLE_SUB`).attr('x', this.getNode('#TITLE_MAIN','width') + 35).text(_d.NAME)

        this.bar_Summary(this.canvas_Equipment, this.svgFile.find(f=> f.ZONE == _d.ZONE && f.SVG == _d.SVG), {idx: 'OV', x: 90,   y: 280, bar: 250})

        this.draw_detail()        

        if (this.current.sn) {
          let detailData = this.eqList.find(f => f.SN = this.current.sn)

          this.update_detail(detailData)
        }      

        this.search.mod = this.current.zone
        this.search.lev = this.current.svg

        if(this.current.toggle == 'off'){
          this.eqList.filter(f=> f.ZONE == this.search.mod && f.SVG == this.search.lev).forEach(d=> {

            let selectText = d3.select(`#NO-${d.ID}`).select('text')

            let cx = Number(d3.select(`#C-${d.ID}`).attr('cx')), tx = 0, ty = 0

            if (selectText.attr(`transform`)) {
              tx = Number(this.gmx_matrix(selectText).x)
              ty = Number(this.gmx_matrix(selectText).y)
              selectText.attr(`transform`, null)
            } else {
              tx = selectText.attr('x')
              ty = selectText.attr('y')
            }

            selectText
            .attr('x', (cx > tx) ? cx-10 : cx+10)
            .attr('y', ty)
            .attr('text-anchor', (cx > tx) ? 'end' : 'start')
            .text(d.DESC)
          })          
        }

        // Search box
        let data__ = {
          x         : 40,
          y         : 240,
          width     : 200,
          height    : 60.5,
          label     : 'Search',
          labelWidth: 40,
          targets: [
            { text: 'TAG No / ' },
            { text: 'Description'},
          ],
          callFunc: this.call_Search// --->  in Event.js
        }
        this.gmx_SearchTool(this.canvas_Equipment, data__) //---> Global function

        if (this.current.search) {
          d3.select('#search_input').text(this.current.search)
          this.call_Search(this.current.search)
        }        
      })       
    },

  },

  watch: {
    selectedItems() {
      this.$emit('selectedItems', this.selectedItems)
    },
  },
}